export default __webpack_public_path__ + "static/media/20s_popup_bg.77b7528c.png";